import React from 'react';

/**
 * Define regras de cores (SLA) por tipo de atendimento.
 * Cada tipo (chave numérica) contém limites de tempo (em minutos)
 * que determinam quando a cor muda conforme o tempo decorrido.
 *
 * - Chave principal: tipo do card (1 = Triagem...)
 * - "limite: null" indica último nível (sem limite)
 */
const regrasCores = {
  // Aguardando Triagem
  // -tipoPaciente
  1: {
    'adulto' : [
      { cor: 'VERDE', limite: 3 },
      { cor: 'AMARELO', limite: 6 },
      { cor: 'VERMELHO', limite: null },
    ],
    'infantil' : [
      { cor: 'VERDE', limite: 8 },
      { cor: 'AMARELO', limite: 15 },
      { cor: 'VERMELHO', limite: null },
    ]
  },

  // Aguardando Cadastro
  // -Situação
  // -tipoPaciente
  2: {
     'Aguardando Atendimento': {
      'adulto' : [
        { cor: 'VERDE', limite: 3 },
        { cor: 'AMARELO', limite: 6 },
        { cor: 'VERMELHO', limite: null },
      ],
      'infantil' : [
        { cor: 'VERDE', limite: 3 },
        { cor: 'AMARELO', limite: 6 },
        { cor: 'VERMELHO', limite: null },
      ]
     },
    'Em Atendimento': {
      'adulto' : [
        { cor: 'VERDE', limite: 10 },
        { cor: 'AMARELO', limite: 15 },
        { cor: 'VERMELHO', limite: null },
      ],
      'infantil' : [
        { cor: 'VERDE', limite: 10 },
        { cor: 'AMARELO', limite: 15 },
        { cor: 'VERMELHO', limite: null },
      ]
    },
  },
  // Aguardando Atendimento Médico
  // -Tipo da pulseira
  3: {
    'VERDE': [
      { cor: 'VERDE', limite: 15 },
      { cor: 'AMARELO', limite: 20 },
      { cor: 'VERMELHO', limite: null },
    ],
    'AMARELO': [
      { cor: 'VERDE', limite: 10 },
      { cor: 'AMARELO', limite: 15 },
      { cor: 'VERMELHO', limite: null },
    ],
  },

	// Aguardando Reavaliação Médica
	4: [
		{ cor: 'VERDE', limite: 10 },
		{ cor: 'AMARELO', limite: 15 },
		{ cor: 'VERMELHO', limite: null },
	],

  // Aguardando Medicação
  // -Tipo Medicação
  5: {
    'Dispensação': [
      { cor: 'VERDE', limite: 10 },
      { cor: 'AMARELO', limite: 15 },
      { cor: 'VERMELHO', limite: null },
    ],
    'Checagem': [
      { cor: 'VERDE', limite: 10 },
      { cor: 'AMARELO', limite: 18 },
      { cor: 'VERMELHO', limite: null },
    ],
  },

  // Aguardando Exames Laboratoriais
  // -StatusAssistencial
  6: {
    'Coleta C/ Med.': [
      { cor: 'VERDE', limite: 10 },
      { cor: 'AMARELO', limite: 15 },
      { cor: 'VERMELHO', limite: null },
    ],
    'Coleta S/ Med.': [
      { cor: 'VERDE', limite: 7 },
      { cor: 'AMARELO', limite: 13 },
      { cor: 'VERMELHO', limite: null },
    ],
    'Laudo S/ Med.': [
      { cor: 'VERDE', limite: 60 },
      { cor: 'VERMELHO', limite: null },
    ],
    'Laudo C/ Med.': [
      { cor: 'VERDE', limite: 60 },
      { cor: 'VERMELHO', limite: null },
    ],
  },

  // Aguardando Exames de Imagem
  // -Tipo do exame
  // -Tipo da pulseira
  7: {
    'COLETA': {
      'VERDE': [
        { cor: 'VERDE', limite: 50 },
        { cor: 'VERMELHO', limite: null },
      ],
      'AMARELO': [
        { cor: 'VERDE', limite: 30 },
        { cor: 'VERMELHO', limite: null },
      ],
      'LARANJA': [
        { cor: 'VERDE', limite: 15 },
        { cor: 'VERMELHO', limite: null },
      ],
      'VERMELHO': [
        { cor: 'VERDE', limite: 10 },
        { cor: 'VERMELHO', limite: null },
      ]
    },
    'LAUDO': {
      'VERDE': [
        { cor: 'VERDE', limite: 120 },
        { cor: 'VERMELHO', limite: null },
      ],
      'AMARELO': [
        { cor: 'VERDE', limite: 120 },
        { cor: 'VERMELHO', limite: null },
      ],
      'LARANJA': [
        { cor: 'VERDE', limite: 60 },
        { cor: 'VERMELHO', limite: null },
      ],
      'VERMELHO': [
        { cor: 'VERDE', limite: 60 },
        { cor: 'VERMELHO', limite: null },
      ]
    }
  },

	// Aguardando Internação
	8: [
		{ cor: 'VERDE', limite: 30 },
		{ cor: 'AMARELO', limite: 40 },
		{ cor: 'VERMELHO', limite: null },
	],
}

export const buscarCorSLA = ({ tipoCard, tempo, pulseira, tipoExame, situacao, tipoMedicacao, tipoPaciente, StatusAssistencial }) => {
  
  const corDefault = 'VERDE';
  const corPulseira = pulseira ?? 'VERDE';
  
  let tempos;

  switch (Number(tipoCard)) {
    case 1:
      tempos = regrasCores[tipoCard]?.[tipoPaciente];
      break;
    case 2:
      tempos = regrasCores[tipoCard]?.[situacao]?.[tipoPaciente];
      break;
    case 3:
      tempos = regrasCores[tipoCard]?.[corPulseira];
      break;
    case 5:
      tempos = regrasCores[tipoCard]?.[tipoMedicacao];
      break;
    case 6:
      tempos = regrasCores[tipoCard]?.[StatusAssistencial];
      break;
    case 7:
      tempos = regrasCores[tipoCard]?.[tipoExame]?.[corPulseira];
      break;
    default:
      tempos = regrasCores[tipoCard];
      break;
  }

  if (!Array.isArray(tempos) || tempos.length === 0) {
    return corDefault;
  }

  for (const { cor, limite } of tempos) {
    if (limite === null || tempo < limite) {
      return cor;
    }
  }

  return corDefault;
};